<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <province-index-category-create-or-update v-model="category"></province-index-category-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    :add-callback="createNew"
                    :settings="false"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import SystemDataApi from '@/api/system-data';
import ProvinceIndexCategoryCreateOrUpdate from './components/ProvinceIndexCategoryCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        ProvinceIndexCategoryCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:'Kategori',key:'Name',thClass:'w-100'},
                {name:'Öncelik',key:'Priority'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            category:{
                Id:null,
                Name:null,
                Priority:null
            },
            editing:false,
            loading:false
        }
    },
    methods:{
        provider(data){
            return SystemDataApi.ProvinceIndexCategory.Table(data)
        },
        clearForm(){
            this.editing = false
            this.category.Id = null
            this.category.Name = null
            this.category.Priority = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.category.Id = item.Id
            this.category.Name = item.Name
            this.category.Priority = item.Priority > 0 ? item.Priority : null
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemDataApi.ProvinceIndexCategory.CreateOrUpdate(this.editing,this.category)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli il katsayı kategori bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDataApi.ProvinceIndexCategory.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>